import { render, staticRenderFns } from "./RejectCaseModalComponent.vue?vue&type=template&id=bfed4480&"
import script from "./RejectCaseModalComponent.vue?vue&type=script&lang=js&"
export * from "./RejectCaseModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports